// bottom-menu.component.ts
import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { AuthenticationService } from "src/app/core/services/auth.service";

@Component({
  selector: "app-bottom-menu",
  templateUrl: "./bottom-menu.component.html",
  styleUrls: ["./bottom-menu.component.scss"],
})
export class BottomMenuComponent implements OnInit, OnDestroy {
  currentRoute: string = "";
  isMobile: boolean = false;
  isLoggedIn = false;

  private routerSubscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    // Escuchar cambios en el estado de autenticación
    this.authService
      .getCurrentUser()
      .then((user) => (authenticated: boolean) => {
        this.isLoggedIn = authenticated;
      });

    this.checkIfMobile();
    this.updateBodyClass();

    // Escuchar cambios de ruta
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });

    // Establecer ruta inicial
    this.currentRoute = this.router.url;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
    document.body.classList.remove("mobile-menu-active");
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.checkIfMobile();
    this.updateBodyClass();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth < 768;
  }

  private updateBodyClass() {
    if (this.isMobile) {
      document.body.classList.add("mobile-menu-active");
    } else {
      document.body.classList.remove("mobile-menu-active");
    }
  }
}
